// Tema claro/oscuro de Inventarios: persistencia en localStorage y paletas de color.
import { useEffect, useState } from "react";

const CLAVE_TEMA = "invent-tema";

export const nombreTema = (oscuro) => (oscuro ? "oscuro" : "claro");

// Oscuro por defecto: solo un "claro" guardado (o un storage inaccesible tras guardarlo) lo desactiva
const leerTemaOscuro = () => {
  try { return localStorage.getItem(CLAVE_TEMA) !== "claro"; } catch { return true; }
};

// [temaOscuro, setTemaOscuro] con persistencia automática
export function useTemaOscuro() {
  const [oscuro, setOscuro] = useState(leerTemaOscuro);
  useEffect(() => {
    try { localStorage.setItem(CLAVE_TEMA, nombreTema(oscuro)); } catch { /* storage no disponible */ }
  }, [oscuro]);
  return [oscuro, setOscuro];
}

// Paleta plana: Precios y Traslados
export const TEMAS_PLANOS = {
  claro: {
    bgApp: "bg-gray-50", bgCard: "bg-white", bgHeader: "bg-gray-100", bgHover: "hover:bg-gray-50",
    bgInput: "bg-white", bgBtn: "bg-white", bgTarjeta: "bg-gray-100/80", bgSkeleton: "bg-gray-200",
    borderMain: "border-gray-200", borderInput: "border-gray-300",
    textMain: "text-black", textSub: "text-gray-600", textInput: "text-black",
    badgePendiente: "bg-amber-100 text-amber-800 border-amber-300",
    badgeOrigen: "bg-blue-100 text-blue-700 border-blue-300",
    badgeDestino: "bg-emerald-100 text-emerald-700 border-emerald-300",
  },
  oscuro: {
    bgApp: "bg-black", bgCard: "bg-[#0f0f11]", bgHeader: "bg-[#18181b]", bgHover: "hover:bg-[#18181b]",
    bgInput: "bg-black", bgBtn: "bg-[#18181b]", bgTarjeta: "bg-white/5", bgSkeleton: "bg-gray-800",
    borderMain: "border-gray-800", borderInput: "border-gray-700",
    textMain: "text-white", textSub: "text-gray-400", textInput: "text-white",
    badgePendiente: "bg-amber-500/20 text-amber-400 border-amber-500/50",
    badgeOrigen: "bg-blue-500/10 text-blue-400 border-blue-500/20",
    badgeDestino: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  },
};

// Paleta "glass": pantalla de Ajustes (Invent.js)
export const TEMAS_GLASS = {
  claro: {
    fondo: "bg-white/60", borde: "border-white/80", bordeSuave: "border-white/70",
    bordeInterno: "border-gray-950/10", bordeFila: "border-gray-950/5",
    textoFuerte: "text-gray-900", textoNormal: "text-gray-800", textoSuave: "text-gray-600", textoMuted: "text-gray-500",
    cardBg: "bg-white/40", cardBorde: "border-white/70", inputBg: "bg-white/70", inputBorde: "border-white/90",
    btnBg: "bg-white/70 hover:bg-white", btnBorde: "border-white", btnTexto: "text-gray-800",
    thead: "bg-white/90", hoverFila: "hover:bg-white/60", modalBg: "bg-white",
    badgeGray: "bg-gray-500/10 text-gray-800 border-gray-500/20",
    badgeBlue: "bg-blue-500/10 text-blue-800 border-blue-500/20",
    badgeGreen: "bg-emerald-500/10 text-emerald-800 border-emerald-500/20",
    badgeRed: "bg-red-500/10 text-red-800 border-red-500/20",
    badgeAmber: "bg-amber-500/10 text-amber-800 border-amber-500/20",
  },
  oscuro: {
    fondo: "bg-gray-900/60", borde: "border-gray-800", bordeSuave: "border-gray-700",
    bordeInterno: "border-gray-800", bordeFila: "border-gray-800",
    textoFuerte: "text-gray-100", textoNormal: "text-gray-200", textoSuave: "text-gray-400", textoMuted: "text-gray-500",
    cardBg: "bg-gray-800/40", cardBorde: "border-gray-700/70", inputBg: "bg-gray-800/70", inputBorde: "border-gray-700",
    btnBg: "bg-gray-800/70 hover:bg-gray-800", btnBorde: "border-gray-700", btnTexto: "text-gray-100",
    thead: "bg-gray-800/90", hoverFila: "hover:bg-gray-800/60", modalBg: "bg-gray-900",
    badgeGray: "bg-gray-400/20 text-gray-100 border-gray-400/40",
    badgeBlue: "bg-blue-400/20 text-blue-100 border-blue-400/40",
    badgeGreen: "bg-emerald-400/20 text-emerald-100 border-emerald-400/40",
    badgeRed: "bg-red-400/20 text-red-100 border-red-400/40",
    badgeAmber: "bg-amber-400/20 text-amber-100 border-amber-400/40",
  },
};